var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7716 3.33104C22.0761 3.02655 22.0761 2.53286 21.7716 2.22837C21.4672 1.92388 20.9735 1.92388 20.669 2.22837L14.5976 8.29998C12.9242 6.99555 10.721 6.63777 8.74988 7.2897L16.7098 15.2499C17.3616 13.279 17.0041 11.0761 15.7001 9.40273L21.7716 3.33104Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06667 8.14533C7.12041 8.10694 7.17458 8.0695 7.22915 8.03302L15.9665 16.7707C15.93 16.8253 15.8926 16.8794 15.8542 16.9332L12.8737 21.106C12.107 22.1794 10.56 22.3074 9.62734 21.3747L2.62527 14.3724C1.69257 13.4397 1.8206 11.8927 2.89394 11.126L7.06667 8.14533Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroom);
export default __webpack_public_path__ + "static/media/broom.0178955ecc7567369c9e782e3a5a57a9.svg";
export { ForwardRef as ReactComponent };